(ns app.front.view.search.dashboard-widget
  (:require [app.front.ui :as ui]
            [app.front.view.recently-viewed :as recently-viewed]
            [app.front.view.search.core :as search]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.feature-flags :as ff]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.front.session :as session]
            [re-frame.core-instrumented :as rf]))

(def ^:private recently-viewed-card-count
  "How many of the most recently visited entities are shown as cards on the dashboard."
  3)

(rf/reg-event-fx ::fetch-recently-viewed
  ;; The feature flags are only known once the session has been restored, so this is checked here
  ;; rather than in the dashboard controller.
  (fn [{:keys [db]} _]
    (when (and (ff/enabled? :feature-flag.id/workspace-search-updates)
               (or (-> db :session/user :user/authority?)
                   (session/admin? (:session/user db))))
      {:dispatch [::recently-viewed/fetch recently-viewed-card-count]})))

(defn recently-viewed-widget [tr]
  (when-some [rows (seq (take recently-viewed-card-count (<sub [::recently-viewed/rows])))]
    [:section.dashlet.bg-ui-white.rounded.p-4.md:p-6
     [:h2 (tr [:workspace-search/recently-viewed])]
     [:div.flex.flex-col.lg:flex-row.lg:items-center.gap-4
      [:div.flex-1.min-w-0
       [recently-viewed/grid-results tr rows]]
      [ui/button {:kind          :ghost
                  :size          :small
                  :icon          i/arrow-right
                  :icon-position :right
                  :href          (href/href :view/recently-viewed)
                  :class-name    "flex-none font-semibold uppercase whitespace-nowrap"}
       (tr [:recently-viewed/view-more])]]]))

(defn record-search-widget [tr]
  [:section.dashlet.bg-ui-white.rounded.p-4.md:p-6
   [:div.mb-8.flex.items-center.justify-between.gap-3
    [:h2.flex.items-center.gap-3
     (cc/icon {:icon        i/search
               :description ""
               :aria-hidden true
               :height      "22"
               :width       "22"})
     (tr [:search/record-search])]
    [search/saved-searches-dropdown-section tr]]
   [search/search-bar tr]])
